// extracted by mini-css-extract-plugin
export default {"nav-item":"navigation_nav-item__JvhLi","nav-link-item":"navigation_nav-link-item__cP8WZ","nav-controls":"navigation_nav-controls__GuTTG"};